import { render, staticRenderFns } from "./SqlDatasourceCard.vue?vue&type=template&id=cd408a7e&scoped=true&"
import script from "./SqlDatasourceCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./SqlDatasourceCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SqlDatasourceCard.vue?vue&type=style&index=0&id=cd408a7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd408a7e",
  null
  
)

export default component.exports